var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDelete1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 97.78 97.79",
    width: 20,
    height: 20,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M48.89,0C21.93,0,0,21.93,0,48.89s21.93,48.89,48.89,48.89,48.89-21.93,48.89-48.89S75.85,0,48.89,0Zm0,90.18c-22.77,0-41.29-18.52-41.29-41.29S26.12,7.6,48.89,7.6s41.29,18.52,41.29,41.29-18.52,41.29-41.29,41.29Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.54,24.05h-4.51c-1.49-3.58-5.03-6.1-9.14-6.1s-7.65,2.52-9.14,6.1h-4.51c-6.37,0-11.56,5.19-11.56,11.56,0,2.9,2.27,5.28,5.13,5.45v23.15c0,6.87,5.59,12.46,12.46,12.46h15.26c6.87,0,12.46-5.59,12.46-12.46v-23.15c2.86-.17,5.13-2.55,5.13-5.45,0-6.38-5.19-11.56-11.56-11.56Zm-1.17,40.16c0,2.68-2.18,4.86-4.86,4.86h-15.26c-2.68,0-4.86-2.18-4.86-4.86v-23.13h24.97v23.13Zm-29.47-30.74c.71-1.1,1.93-1.82,3.33-1.82h27.31c1.4,0,2.63,.73,3.33,1.82H31.91Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.78,61.64c1.31,0,2.38-1.06,2.38-2.38v-9.42c0-1.31-1.06-2.38-2.38-2.38s-2.38,1.06-2.38,2.38v9.42c0,1.31,1.06,2.38,2.38,2.38Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44,61.64c1.31,0,2.38-1.06,2.38-2.38v-9.42c0-1.31-1.06-2.38-2.38-2.38s-2.38,1.06-2.38,2.38v9.42c0,1.31,1.06,2.38,2.38,2.38Z",
    fill: "#fff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete1);
export default __webpack_public_path__ + "static/media/Delete_1.83a4e5f35f0f947ecec7ac2740d1de59.svg";
export { ForwardRef as ReactComponent };